module.exports = __webpack_public_path__ + "img/3.3f10f5f6.png";